const IGNORED_KEYS = [
  'id',
  'type',
  'approvers_ids',
  'approval_author_id',
  'approval_request_created_at',
  'approval_action_type',
  'request_details',
  'effective_on',
  'created_by_name',
  'created_by_avatar',
  'created_at',
  'action_type',
  'status',
]
const DE_KEYS = [
  'de_contract_type_id',
  'de_flat_rate_tax',
  'de_activity_type',
  'de_employment_type',
  'de_personal_key_group_id',
]
const PT_KEYS = ['pt_contract_type_id']
const ES_KEYS = [
  'es_contract_type_id',
  'es_contract_observations',
  'es_education_level_id',
  'es_has_teleworking_contract',
  'es_job_description',
  'es_professional_category_id',
  'es_working_day_type_id',
  'es_cotization_group_id',
  'es_tariff_group_id',
  'es_tariff_group_name',
]
const FR_KEYS = [
  'fr_coefficient',
  'fr_contract_type_id',
  'fr_employee_type',
  'fr_forfait_jours',
  'fr_jours_par_an',
  'fr_jours_par_an_cents',
  'fr_level_id',
  'fr_mutual_id',
  'fr_professional_category',
  'fr_professional_category_id',
  'fr_step_id',
  'fr_work_type_id',
]

const getIgnoredKeys = (
  country: string,
  hasDevJobCatalogTree?: boolean,
  hasTimeTrackingAnnualisationDailyValue?: boolean,
  hasDevTimeTrackingWorkableDaysDefinition?: boolean,
  hasCompensationsManagement?: boolean
) => {
  const ignoredKeys = IGNORED_KEYS

  if (!hasDevTimeTrackingWorkableDaysDefinition) {
    ignoredKeys.push('bank_holiday_treatment', 'working_time_percentage_in_cents')
  }

  if (!hasTimeTrackingAnnualisationDailyValue) {
    ignoredKeys.push('annual_working_time_distribution')
  }

  if (!hasDevJobCatalogTree) {
    ignoredKeys.push('job_catalog_tree_node_uuid')
  }

  if (!hasCompensationsManagement) {
    ignoredKeys.push('payroll_policy')
  }

  switch (country) {
    case 'es':
      return ignoredKeys.concat(FR_KEYS, DE_KEYS, PT_KEYS)
    case 'fr':
      return ignoredKeys.concat(ES_KEYS, DE_KEYS, PT_KEYS)
    case 'de':
      return ignoredKeys.concat(ES_KEYS, FR_KEYS, PT_KEYS)
    case 'pt':
      return ignoredKeys.concat(ES_KEYS, FR_KEYS, DE_KEYS)
    default:
      return ignoredKeys.concat(ES_KEYS, DE_KEYS, FR_KEYS, PT_KEYS)
  }
}

export default getIgnoredKeys
